"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Inventory = exports.InventoryOutlined = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
function InventoryOutlined(props) {
    return (jsx_runtime_1.jsxs(core_1.SvgIcon, __assign({}, props, { children: [jsx_runtime_1.jsx("g", { children: jsx_runtime_1.jsx("rect", { fill: "none", height: "24", width: "24" }, void 0) }, void 0),
            jsx_runtime_1.jsx("g", { children: jsx_runtime_1.jsxs("g", { children: [jsx_runtime_1.jsx("path", { d: "M20,2H4C3,2,2,2.9,2,4v3.01C2,7.73,2.43,8.35,3,8.7V20c0,1.1,1.1,2,2,2h14c0.9,0,2-0.9,2-2V8.7c0.57-0.35,1-0.97,1-1.69V4 C22,2.9,21,2,20,2z M19,20H5V9h14V20z M20,7H4V4h16V7z" }, void 0),
                        jsx_runtime_1.jsx("rect", { height: "2", width: "6", x: "9", y: "12" }, void 0)] }, void 0) }, void 0)] }), void 0));
}
exports.InventoryOutlined = InventoryOutlined;
function Inventory(props) {
    return (jsx_runtime_1.jsxs(core_1.SvgIcon, __assign({}, props, { children: [jsx_runtime_1.jsx("path", { d: "M0 0h24v24H0V0z", fill: "none" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M20 2H4c-1 0-2 .9-2 2v3.01c0 .72.43 1.34 1 1.69V20c0 1.1 1.1 2 2 2h14c.9 0 2-.9 2-2V8.7c.57-.35 1-.97 1-1.69V4c0-1.1-1-2-2-2zm-5 12H9v-2h6v2zm5-7H4V4l16-.02V7z" }, void 0)] }), void 0));
}
exports.Inventory = Inventory;
//# sourceMappingURL=Inventory.js.map